<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'product'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">Add Product</h1>
						</div>
						<div class="product-card-wrapper">
							<div class="all-wrapper">
								<div class="search-container">
									<div class="search-product-inner">
										<div class="search-block">
											<!-- 新增：多级分类选择器 -->
											<el-cascader v-model="queryParams.category" :options="categoryOptions"
												placeholder="All categories" clearable @change="handleCategoryChange"
												style="width: 100%; max-width: 200px; margin-right: 10px;"
												:props="{ checkStrictly: false }" :show-all-levels="false"></el-cascader>
										</div>
										<div class="search-block">
											<el-input v-model="queryParams.productName" placeholder="Product Name"
												clearable></el-input>
										</div>
									</div>
									<div class="search-btns" style="margin-top: 5px;">
										<el-button type="primary" size="small" @click="getList">
											Search
										</el-button>
										<el-button size="small" @click="reset">Reset
										</el-button>
									</div>
								</div>
								<div class="table-wrap product-card-table">
									<el-table ref="multipleTable" :data="tableData" style="width: 100%"
										@selection-change="handleSelectionChange"  :row-class-name="tableRowClassName">
									    <el-table-column type="selection" width="42" :selectable="checkSelectable"></el-table-column>
										<el-table-column prop="name" label="Icon" width="100">
											<template v-slot="scope">
												<el-image style="width: 80px; height: 80px" :src="scope.row.icon">
												</el-image>
											</template>
										</el-table-column>
										<el-table-column prop="productName" label="Name"></el-table-column>
										<el-table-column prop="discountPrice" label="Price" width="100">
										</el-table-column>
									</el-table>
								</div>
								<div class="page-contrainer d-flex">
									<el-pagination :page-count="isMobile ? 4 : 10" background layout="prev, pager, next" :total="total"
										:current-page.sync="queryParams.pageNum" @current-change="getList">
									</el-pagination>
								</div>
							</div>

							<div class="card-option-block">
								<el-button type="primary" @click="addStoreProduct">Add<i
										class="el-icon-arrow-right el-icon--right"></i></el-button>
							</div>
							<div class="select-wrapper">
								<div class="search-container">
									<div class="search-btns">
										<!--										<el-button type="primary" @click="deleteStoreProduct" size="small">{{ $t('button.delete') }}</el-button>-->
									</div>
								</div>
								<div class="table-wrap product-card-table">
									<el-table ref="delMultipleTable" :data="storeProductList" style="width: 100%"
										@selection-change="deleteSelectionChange">
										<el-table-column type="selection" width="42"></el-table-column>
										<el-table-column prop="productName" label="Name"></el-table-column>
										<el-table-column prop="discountPrice" label="Price" width="80">
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="z-zone"></div>
		<tabBar current="1"></tabBar>
	</div>


</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		getList
	} from "@/api/product";
	import {
		selectStoreProduct,
		addStoreProduct,
		deleteStoreProduct,
		queryTypelist
	} from "@/api/storeProduct";

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				pageNo: 20,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					productName: null,
					category: null // 新增：分类查询条件
				},
				categoryOptions: [

				],
				queryStoreProduct: {
					pageNum: 1,
					pageSize: 10,
					productName: null
				},
				// 总条数
				total: 0,
				tableData: [],
				storeProductList: [],
				multipleSelection: [],
				// 删除选中项
				deleteSelection: [],
				isMobile:false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getList();
			this.getStoreProduct();
			this.selectTypelist();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			selectTypelist() {
				queryTypelist().then(res => {
					if (res.code == 200) {
						this.categoryOptions = res.data;
					}
				})
			},
			handleCategoryChange(value) {
				// value 是数组，例如 ['epidemic', 'medical-masks']
				if (value && value.length === 2) {
					this.queryParams.category = value[1]; // 使用二级分类值作为过滤条件
					this.getList(); // 自动触发搜索
				} else {
					this.queryParams.category = null;
				}
			},
			deleteStoreProduct() {
				if (this.deleteSelection.length == 0) {
					this.$message.warning('Please select at least one item');
					return false;
				}
				deleteStoreProduct(this.deleteSelection).then(res => {
					if (res.code == 200) {
						this.$message({
							message: 'Delete Success',
							type: 'success'
						});
						this.getStoreProduct();
						this.getList();
					} else {
						return false;
					}
				})
			},
			addStoreProduct() {
				if (this.multipleSelection.length == 0) {
					this.$message.warning('Please select at least one item');
					return false;
				}
				addStoreProduct(this.multipleSelection).then(res => {
					if (res.code == 200) {
						this.$message({
							message: 'Add Success',
							type: 'success'
						});
						this.getStoreProduct();
						this.getList();
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
						return false;
					}
				})
			},
			reset() {
				this.queryParams = {
					pageNum: 1,
					pageSize: 10,
					productName: null
				}
				this.getList();
			},
			getList() {
				const params = {
					...this.queryParams,
					category: this.queryParams.category || null
				};
				getList(params).then(res => {
					if (res.code == 200) {
						this.tableData = res.rows;
						this.total = res.total;
              // Add the row selection logic here
            this.$nextTick(() => {
              this.tableData.forEach(row => {
                // if (row.cksta === 1) {
                //   this.$refs.multipleTable.toggleRowSelection(row, true);
                // }
              });
            });
					} else {
						this.$message.error(res.msg || 'Failed to load products');
					}
				});
			},
			getStoreProduct() {
				// selectStoreProduct(this.queryStoreProduct).then(res => {
				// 	if (res.code == 200) {
				// 		this.storeProductList = res.rows;
				// 		this.total = res.total;
				// 	} else {
				// 		return false;
				// 	}
				// })
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
       checkSelectable(row, index) {
    // Return false for rows that should not be selectable
    return row.cksta !== 1;
  },

  tableRowClassName({row, rowIndex}) {
    // Apply special styling to disabled rows
    if (row.cksta === 1) {
      return 'is-disabled';
    }
    return '';
  },
			handleSelectionChange(val) {
				this.multipleSelection = val;
        this.storeProductList = val.map(item => {
        return {
          productId: item.productId,
          productName: item.productName,
          discountPrice: item.discountPrice
        };
      });


			},
			deleteSelectionChange(val) {
				this.deleteSelection = val;


			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/product.css");

	.search-product-inner {
		width: calc(100% - 180px);
		display: grid;
		grid-template-columns: repeat(2, minmax(0px, 1fr));
		gap: 0px 20px;
	}
	@media (max-width: 767px) {
		.search-btns {
			width: 204px;
		}
	}

	@media (max-width: 767px) {
		.search-container {
			flex-wrap: wrap;
			gap: 8px;
		}

		.search-block {
			width: 100%;
			min-width: 100px;
		}

		.search-btns {
			width: 100%;
			display: flex;
			justify-content: flex-end;
			gap: 8px;
		}
		.search-product-inner {
			width: 100%;
			display: grid;
			grid-template-columns: repeat(2, minmax(0px, 1fr));
			gap: 0px 20px;
		}

		.el-cascader {
			width: 100% !important;
			max-width: none;
		}

		.el-input {
			width: 100% !important;
		}
	}
  /* Add this to your <style> section */
.el-table__row.is-disabled {
  background-color: #f5f7fa;
  color: #c0c4cc;
  pointer-events: none;
}

.el-table__row.is-disabled .cell {
  color: #c0c4cc;
}

</style>
